import React, { useState } from 'react';
import { FaQuoteRight } from 'react-icons/fa';
import CiteModal from './CiteModal.js';

/**
 * Opens the citation dialog for one article, or for a whole volume when
 * `articles` is passed instead.
 *
 * The dialog is only mounted once it is asked for, so the volume listing can
 * render a Cite control on every row without building a dialog for each.
 *
 * @param {'icon'|'link'} variant  icon matches the PDF controls on the article
 *   page; link matches the View / PDF buttons in the volume listing.
 */
const CiteButton = ({ article, articles, siblings, year, variant = 'link', label = 'Cite' }) => {
  const [open, setOpen] = useState(false);

  const title = articles ? `Cite every article in volume ${year}` : 'Cite this article';

  return (
    <>
      <button
        type="button"
        className={variant === 'icon' ? 'cite-icon-btn' : 'cite-link-btn'}
        onClick={() => setOpen(true)}
        title={title}
        aria-label={title}
        aria-haspopup="dialog"
      >
        {variant === 'icon' ? <FaQuoteRight className="icon" /> : label}
      </button>

      {open && (
        <CiteModal
          article={article}
          articles={articles}
          siblings={siblings}
          year={year}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default CiteButton;
